<div class="wrapper">
    <ag-grid-angular
      class="ag-theme-alpine-dark ag-theme-ix"
      style="height: 100%; width: 100%;"

      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [autoGroupColumnDef]="autoGroupColumnDef"
      [rowData]="rowData"
      [getDataPath]="getDataPath"
      [treeData]="true"
      [groupDefaultExpanded]="groupDefaultExpanded"
      [gridOptions]="gridOptions"
      [rowSelection]="rowSelection"
      [groupSelectsChildren]="true"
      [animateRows]="true"
      [domLayout]="domLayout"
      [getRowId]="getRowId"
      [rowClassRules]="rowClassRules"
      (gridReady)="onGridReady($event)"
      (rowSelected)="onRowSelected($event)"
      (rowGroupOpened)="onRowGroupOpened($event)"
      (paginationChanged)="onPaginationChanged($event)"
      >
    </ag-grid-angular>
</div>